/**
 * @generated SignedSource<<0e2cdcef8dcfebdff39ba9650da81044>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HorizontalNavBoardHeader_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavigationTeamButton_project" | "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs" | "extraComponentsFar_horizontalNav" | "ui_navigationBoardActionMenu_BoardActions">;
  readonly " $fragmentType": "HorizontalNavBoardHeader_project";
};
export type HorizontalNavBoardHeader_project$key = {
  readonly " $data"?: HorizontalNavBoardHeader_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavBoardHeader_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "isTMPBoardRoute"
    }
  ],
  "kind": "Fragment",
  "name": "HorizontalNavBoardHeader_project",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "NavigationTeamButton_project"
        }
      ]
    },
    {
      "condition": "isTMPBoardRoute",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ui_navigationBoardActionMenu_BoardActions"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "extraComponentsFar_horizontalNav"
    },
    {
      "kind": "FragmentSpread",
      "name": "breadcrumbs_horizontalNav_HorizontalNavProjectBreadcrumbs"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "0182ef8ea67e2047a2c73a62c74cf453";

export default node;
